/* istanbul ignore file */
// Generated code for Big.Webservice.Controllers.EmailController.
// Edit _ApiService.tst to change the generated output.
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { HttpClient } from '@angular/common/http';
import { ZorroApiClient } from '../zorro-api-client';


@Injectable()
export class EmailApiService extends ZorroApiClient {

    constructor(
      private readonly httpClient: HttpClient
    ) {
        super();
    }

    public validate(email: string, spinnerMessage: string = null): Observable<boolean> {
        return this.httpClient.get<boolean>(`/api/email/validate?email=${encodeURIComponent(email)}`,
        {params: this.createOptions(null, spinnerMessage)}); // tslint:disable-line //NOSONAR
    }

    public isUnique(email: string, spinnerMessage: string = null): Observable<boolean> {
        return this.httpClient.get<boolean>(`/api/email/is-unique?email=${encodeURIComponent(email)}`,
        {params: this.createOptions(null, spinnerMessage)}); // tslint:disable-line //NOSONAR
    }


}
